import React, { Component } from "react";
import Button from "../../../../components/form/Button";
import { postFile } from "../../CroActions";
import { noop } from "lodash";

export const ALLOWED_FILE_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xml",
  ".xls",
  ".xlsx",
  ".odt",
  ".ods",
  ".rtf",
  ".msg",
  ".csv",
  ".jpg",
  ".jpeg",
  ".png"
];

export const ALLOWED_FILE_ACCEPT = ALLOWED_FILE_EXTENSIONS.join(",");

const isFileExtensionAllowed = (fileName) => {
  const ext = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
  return ALLOWED_FILE_EXTENSIONS.includes(ext);
};

export default class FileUpload extends Component {
  static defaultProps = {
    disabled: false,
    label: "Nahrát soubor",
    url: "/api/files/",
    onFileUploaded: noop,
  };

  onClick = () => {
    if (this.fileInput) {
      this.fileInput.click();
    }
  };

  onFileChange = async (e) => {
    const { onFileUploaded, url, dispatch, loadingText } = this.props;
    const file = e.target.files[0];
    if (!file) return;

    if (!isFileExtensionAllowed(file.name)) {
      alert(
        `Nepodporovaný formát souboru. Povolené formáty: ${ALLOWED_FILE_EXTENSIONS.join(", ")}`,
      );
      e.target.value = "";
      return;
    }

    const fileRef = await postFile(file, url, dispatch, loadingText);
    onFileUploaded(fileRef);
  };

  render() {
    const {
      disabled,
      label,
      helpEnum,
      tooltipPosition,
      className,
      accept,
      children,
    } = this.props;
    const fileInput = (
      <input
        type="file"
        style={{ display: "none" }}
        ref={(node) => (this.fileInput = node)}
        onChange={this.onFileChange}
        accept={accept}
      />
    );

    if (children) {
      return (
        <React.Fragment>
          {fileInput}
          {React.cloneElement(children, {
            onClick: disabled ? undefined : this.onClick,
          })}
        </React.Fragment>
      );
    }

    return (
      <div className={className}>
        {fileInput}
        <Button
          type="button"
          label={label}
          disabled={disabled}
          onClick={this.onClick}
          helpEnum={helpEnum}
          tooltipPosition={tooltipPosition}
        />
      </div>
    );
  }
}
